import { render, staticRenderFns } from "./EditChangelogType.vue?vue&type=template&id=3ad627a7&"
import script from "./EditChangelogType.vue?vue&type=script&lang=ts&"
export * from "./EditChangelogType.vue?vue&type=script&lang=ts&"
import style0 from "./EditChangelogType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports